import axios, { AxiosResponse, ResponseType } from 'axios'
import { LocalStorageService } from '../../services/storage/local-storage.service'
import { TokenPrimeService } from '../../services/token/token.service'

// Get backend URL from environment variable
const getBackendUrl = (): string => {
  if (process.env.REACT_APP_SERVER_ENV === 'DEV') {
    return process.env.REACT_APP_SERVER_URL || 'http://localhost:8080'
  }
  // In production, use relative path (same origin as frontend)
  return process.env.REACT_APP_SERVER_URL || '/api'
}

const backendUrl = getBackendUrl()

export const InternalServerError = {
  message: 'Internal error occured during the request.',
  code: -500,
}

export const onFulfilledRequest = (response: AxiosResponse) => response

// eslint-disable-next-line
export const onRejectedRequest = (error: any) => {
  // Just return the error without forcing logout on 401
  // Let the application handle 401s gracefully
  return Promise.reject(error)
}

// eslint-disable-next-line
export const publicApiRequest = async (url?: string, responseType?: ResponseType) => {
  return axios.create({
    baseURL: url || backendUrl,
    responseType: responseType,
    withCredentials: true, // Enable sending cookies with requests
  })
}

// Create a default instance for interceptors
const defaultInstance = axios.create({
  baseURL: backendUrl,
  withCredentials: true,
})

// Add request interceptor to include Authorization header
defaultInstance.interceptors.request.use(
  async (config) => {
    // Get access token from cookies via token service
    try {
      const tokenServicePrime = new TokenPrimeService()
      const tokenData = await tokenServicePrime.getTokenPairToCookie()

      // Only add Authorization header if we have a valid token (not null/undefined)
      if (tokenData?.description?.accessToken && tokenData.description.accessToken !== 'null') {
        config.headers.Authorization = `Bearer ${tokenData.description.accessToken}`
      } else {
        console.warn('⚠️ No valid token available for request to:', config.url)
      }
    } catch (error) {
      // If token retrieval fails, continue without auth header
      console.warn('⚠️ Could not retrieve token for request:', error)
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

defaultInstance.interceptors.response.use(onFulfilledRequest, onRejectedRequest)

export { defaultInstance }
